import { render, staticRenderFns } from "./modalAdicionarItens.vue?vue&type=template&id=71d07dc3&scoped=true&"
import script from "./modalAdicionarItens.vue?vue&type=script&lang=js&"
export * from "./modalAdicionarItens.vue?vue&type=script&lang=js&"
import style0 from "./modalAdicionarItens.vue?vue&type=style&index=0&id=71d07dc3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d07dc3",
  null
  
)

export default component.exports